import { EventEmitter, Injectable } from '@angular/core';
import { AsyncInfoRequestViewModel, AsyncInfoResponseViewModel } from './asyncInfo.types';

@Injectable()
export class AsyncInfoService {
    requestAsyncInfoEvent = new EventEmitter<AsyncInfoRequestViewModel>(true);
    responseAsyncInfoEvent = new EventEmitter<AsyncInfoResponseViewModel>(true);

    constructor() {}

    notifyRequest(async: AsyncInfoRequestViewModel) {
        this.requestAsyncInfoEvent.emit(async);
    }

    notifyResponse(async: AsyncInfoResponseViewModel) {
        this.responseAsyncInfoEvent.emit(async);
    }
}
